<template>
  <div class="upcoming-bootcamps">
    <div
      class="upcoming-bootcamps__bootcamp"
      v-for="bootcamp in bootcamps"
      :key="bootcamp.id"
    >
      <HomeBootcamp :bootcamp="bootcamp" :isMobile="isMobile" />
    </div>
  </div>
</template>
<script>
import HomeBootcamp from './HomeBootcamp.vue'

export default {
  name: 'UpcomingBootcamps',
  components: { HomeBootcamp },
  props: {
    bootcamps: {
      type: Array,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
